import { downloadCsv } from '../../../lib/downloadBlob';
import { dashboardT } from '../../../lib/messages';
import type { ChangelogEntry } from '../../changelog/model';
import {
  changelogCategoryLabel,
  changelogContextLabel,
  changelogFieldLabel,
  displayChangelogValue,
} from '../../changelog/presentation';

export function createChangelogCsv(entries: ChangelogEntry[]) {
  const rows = entries.map((entry) => [
    entry.createdOn,
    changelogCategoryLabel(entry.category),
    changelogContextLabel(entry),
    changelogFieldLabel(entry),
    entry.type,
    displayChangelogValue(entry.oldValue),
    displayChangelogValue(entry.newValue),
    entry.createdBy ?? '',
  ]);
  return [
    [
      dashboardT('changelog.csv.created'),
      dashboardT('changelog.csv.category'),
      dashboardT('changelog.csv.contextName'),
      dashboardT('changelog.csv.fieldName'),
      dashboardT('changelog.csv.type'),
      dashboardT('changelog.csv.oldValue'),
      dashboardT('changelog.csv.newValue'),
      dashboardT('changelog.csv.createdBy'),
    ],
    ...rows,
  ]
    .map((row) => row.map(escapeCsvValue).join(','))
    .join('\r\n');
}

export function downloadChangelogCsv(entries: ChangelogEntry[]) {
  downloadCsv(createChangelogCsv(entries), 'changelog-records.csv');
}

function escapeCsvValue(value: string | number) {
  const text = String(value);
  const safeText = /^[=+\-@]/.test(text) ? `'${text}` : text;
  return /[",\r\n]/.test(safeText) ? `"${safeText.replaceAll('"', '""')}"` : safeText;
}
